import React from "react";
import { ErrorAlert, Input, InputRow } from "./";

/**
 * Matches what the server accepts before it will send anything. The endpoint is unauthenticated and
 * answers identically whether or not an account exists, so this check is the only feedback a user
 * gets that they typed their address wrong.
 */
export const isValidEmailAddress = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

interface ForgotPasswordFormFieldsProps {
    email: string;
    onEmailChange: (email: string) => void;
    onEnter: () => void;
    error?: string;
    showDescription?: boolean;
    description?: string;
}

export const ForgotPasswordFormFields: React.FC<ForgotPasswordFormFieldsProps> = ({ email, onEmailChange, onEnter, error, showDescription = true, description = "Please enter your email address below and we will send you an email with a link to reset your password." }) => {
    return (
        <>
            {showDescription && (
                <div className="mb-4">
                    <p className="text-sm text-gray-600 mb-4">{description}</p>
                </div>
            )}

            <ErrorAlert errors={error} />

            <div className="space-y-4">
                <InputRow>
                    <Input label="Email Address" type="email" autoComplete="email" value={email} onChange={(e) => onEmailChange(e.target.value)} onEnter={onEnter} />
                </InputRow>
            </div>
        </>
    );
};
